export default {
  confirmLabel: 'Done',
  backspaceLabel: 'Backspace',
  cancelKeyboardLabel: 'CancelKeyboard'
}



// WEBPACK FOOTER //
// ./src/components/input-item/locale/en_US.js